window.mixpanel.init(process.env.MIXPANEL_TOKEN, {
  protocol: 'https'
});

export default window.mixpanel;


// WEBPACK FOOTER //
// ./src/helpers/mixpanel.js